export default ($) => {
  $('input[data-radiogroup]').change(function () {
    $('input[data-radiogroup]:checked').not(this).prop('checked', false)
  })
}
